import React from 'react'
import { Button } from 'react-bootstrap'

const TOKENS = [
  { token: '{{primeiro_nome}}', label: '+ Primeiro nome' },
  { token: '{{nome}}', label: '+ Nome completo' },
]

// Insere o nome do paciente ({{primeiro_nome}} ou {{nome}}) onde está o cursor do campo
const NameTokenButtons = ({ inputRef, value, onChange, disabled, maxLength }) => {
  function insert(token) {
    const input = inputRef.current
    const start = input ? input.selectionStart : value.length
    const end = input ? input.selectionEnd : value.length
    if (maxLength && (value.length - (end - start) + token.length > maxLength)) return

    onChange(value.slice(0, start) + token + value.slice(end))

    requestAnimationFrame(() => {
      if (!input) return
      input.focus()
      input.setSelectionRange(start + token.length, start + token.length)
    })
  }

  return (
    <div className='d-flex flex-wrap gap-2'>
      {TOKENS.map((item) => (
        <Button key={item.token} variant='outline-secondary' size='sm' disabled={disabled} title={`Insere ${item.token}`} onClick={() => insert(item.token)}>
          {item.label}
        </Button>
      ))}
    </div>
  )
}

export default NameTokenButtons
